import React from "react";
import ShippingOverview from "../ShippingOverview/ShippingOverview";
import OrderOverview from "../OrderOverview/OrderOverview";
import { useSelector } from "react-redux";
// import { cancelledItemsSelector } from "../../../lib/store/reducers/cancelledItemReducer";
// import CancelledItems from "../CancelledItems/CancelledItems";
import CancelledItemsOverview from "../CancelledItemsOverview/CancelledItemsOverview";
import {
  isForcedRestockStageSelector,
  isRestockCancelledItemsStageSelector,
} from "../../../lib/store/reducers/globalStateReducer";
import RestockOverview from "../RestockOverview/RestockOverview";

type Props = {
  isReviewMode: boolean;
};

const MainOverview = ({ isReviewMode }: Props) => {
  // const cancelledItems = useSelector(cancelledItemsSelector);
  const isRestockCancelledItemsStage = useSelector(isRestockCancelledItemsStageSelector);
  const isForcedRestockStage = useSelector(isForcedRestockStageSelector);
  console.log("🚀 ~ MainOverview ~ isForcedRestockStage:", isForcedRestockStage);
  if (isReviewMode) return <ShippingOverview />;
  if (isRestockCancelledItemsStage) return <CancelledItemsOverview />;
  if (isForcedRestockStage) return <RestockOverview />;
  return <OrderOverview />;
};

export default MainOverview;
